import {
  type Form,
  isShippingProviderType,
  type ProviderAccountSource,
  type Rate,
  ShippingProviderType,
} from "@redotech/redo-fulfillment-carrier-common/shipment";

const QR_FORM_TYPES = new Set(["QR_CODE", "rma_qr_code", "label_qr_code"]);

/** Carriers that support QR code generation for return labels. */
export const QR_SUPPORTED_CARRIERS = new Set([
  "USPS",
  "USPSReturns",
  "FedEx",
  "FedExSmartPost",
  "CanadaPost",
  "DPD", // WeGrow labels use DPD as the carrier
]);

export function isQrCodeForm(form: Form): boolean {
  return QR_FORM_TYPES.has(form.form_type) && !!form.form_url;
}

export function findQrCodeForm(forms: Form[] | undefined): Form | undefined {
  return forms?.find(isQrCodeForm);
}

// EasyPost files a merchant-account FedEx RMA against the merchant's own FedEx
// account; FedEx direct always files against Redo's, whoever pays for the label.
export function willRateHaveQrCode(
  rate: Pick<Rate, "carrier" | "is_merchant_carrier_account" | "options"> &
    ProviderAccountSource,
  settings: {
    generateQrCodes: boolean;
    fedexQrCodesEnabledForMerchantRates?: boolean | null;
  },
): boolean {
  if (!rate.options?.qrCodeAvailable) {
    return false;
  }
  if (!settings.generateQrCodes) {
    return false;
  }
  const isFedEx = rate.carrier === "FedEx" || rate.carrier === "FedExSmartPost";
  if (
    isFedEx &&
    rate.is_merchant_carrier_account &&
    !isShippingProviderType(rate, ShippingProviderType.FEDEX_DIRECT)
  ) {
    return !!settings.fedexQrCodesEnabledForMerchantRates;
  }
  return true;
}
